import { render, staticRenderFns } from "./CharacterBuilder.vue?vue&type=template&id=584c6eab"
import script from "./CharacterBuilder.vue?vue&type=script&lang=js"
export * from "./CharacterBuilder.vue?vue&type=script&lang=js"
import style0 from "./CharacterBuilder.vue?vue&type=style&index=0&id=584c6eab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports